import { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";

const STORAGE_KEY = "mdm_pw_dl";
function getStore() {
  try {
    localStorage.setItem("_t", "1");
    localStorage.removeItem("_t");
    return localStorage;
  } catch (e) {
    try {
      sessionStorage.setItem("_t", "1");
      sessionStorage.removeItem("_t");
      return sessionStorage;
    } catch (e2) {
      return null;
    }
  }
}
const CheckIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="#fff"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
const StarIcon = () => (
  <svg viewBox="0 0 24 24">
    <path
      fill="#F5A623"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
    />
  </svg>
);
const ArrowIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);
const ShieldIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="#0FAA5C"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);
const TickIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="#0FAA5C"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
const CircleTickIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="#0FAA5C"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M8 12l2 2 4-4" />
  </svg>
);

const CHECKLIST = [
  "Question Paper Creator / प्रश्न पत्र",
  "Timetable Generator / समय सारिणी",
  "Academic Calendar / शैक्षणिक कैलेंडर",
  "Teacher Planner / टीचर प्लानर",
  "Documents Module / डॉक्युमेंट्स",
  " Event Organiser & Quiz / इवेंट ऑर्गेनाइजर एवं क्विज",
];

function useCountdown() {
  const store = useRef(getStore());
  // const [time, setTime] = useState({ h: 23, m: 59, s: 59, expired: false });
  const [time, setTime] = useState({ h: 1, m: 59, s: 59, expired: false });
  useEffect(() => {
    let dl = store.current ? store.current.getItem(STORAGE_KEY) : null;
    if (!dl || new Date(dl) <= new Date()) {
      // dl = new Date(Date.now() + 86400000).toISOString(); // 24 hours
      dl = new Date(Date.now() + 7200000).toISOString(); // 2 hours
      if (store.current) store.current.setItem(STORAGE_KEY, dl);
    }
    const go = () => {
      const d = Math.max(0, Math.floor((new Date(dl) - new Date()) / 1000));
      if (d === 0) {
        setTime({ h: 0, m: 0, s: 0, expired: true });
        return;
      }
      setTime({
        h: Math.floor(d / 3600),
        m: Math.floor((d % 3600) / 60),
        s: d % 60,
        expired: false,
      });
    };
    go();
    const id = setInterval(go, 1000);
    return () => clearInterval(id);
  }, []);
  return time;
}
const pad = (n) => String(n).padStart(2, "0");

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@500;700;800&family=Noto+Sans+Devanagari:wght@500;600;700&display=swap');
.pw,.pw *,.pw *::before,.pw *::after{margin:0;padding:0;box-sizing:border-box}
.pw{font-family:"Outfit","Noto Sans Devanagari",-apple-system,sans-serif;color:#1A1D2E;-webkit-font-smoothing:antialiased;background:#F5F6FA;border-radius:24px;overflow:hidden;max-width:480px;width:100%;box-shadow:0 24px 80px rgba(0,0,0,.16)}
.pw .hero{background:linear-gradient(168deg,#0052CC 0%,#002B6B 50%,#001A45 100%);padding:28px 28px 44px;text-align:center;position:relative;overflow:hidden}
.pw .hero::before{content:"";position:absolute;top:-50%;right:-25%;width:280px;height:280px;border-radius:50%;background:radial-gradient(circle,rgba(255,107,44,.1) 0%,transparent 70%);pointer-events:none}
.pw .logo-slot{height:28px;margin-bottom:16px;display:flex;justify-content:center;align-items:center}
.pw .status-row{display:flex;align-items:center;justify-content:center;gap:12px;margin-bottom:16px;flex-wrap:wrap;animation:pFd .5s ease-out}
.pw .pill{display:inline-flex;align-items:center;gap:6px;background:rgba(15,170,92,.15);border:1px solid rgba(15,170,92,.3);border-radius:100px;padding:6px 16px}
.pw .pill .ck{width:16px;height:16px;background:#0FAA5C;border-radius:50%;display:grid;place-items:center;flex-shrink:0}
.pw .pill .ck svg{width:10px;height:10px}
.pw .pill span{color:#B0F0D0;font-size:13px;font-weight:600}
.pw .stars-mini{display:flex;gap:1px;  justify-content: center; 
  align-items: center;}
.pw .stars-mini svg{width:16px;height:16px}
.pw .proof-num{color:rgba(255,255,255,.7);font-size:12px;font-weight:500;letter-spacing:.03em}
.pw .proof-num b{color:#fff;font-weight:700}
.pw .hl{animation:pFd .55s ease-out .05s both}
.pw .hl h1{font-size:28px;font-weight:800;color:#fff;line-height:1.2;letter-spacing:-.01em}
.pw .hl h1 em{font-style:normal;color:#FF6B2C}
.pw .content{padding:0 24px 28px;margin-top:-22px;position:relative;z-index:2}
.pw .checklist{background:#fff;border-radius:16px;padding:18px 22px;box-shadow:0 4px 20px rgba(0,40,100,.07);margin-bottom:14px;animation:pFu .45s ease-out .1s both}
.pw .checklist-label{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.1em;color:#0052CC;margin-bottom:12px}
.pw .check-item{display:flex;align-items:center;gap:10px;padding:7px 0;pointer-events:none;user-select:none}
.pw .check-ico{width:16px;height:16px;flex-shrink:0}
.pw .check-item span{font-size:14px;font-weight:500;color:#1A1D2E;line-height:1.35}
.pw .urgency{background:linear-gradient(135deg,#FFF5E6 0%,#FFFAF0 100%);border:1px solid rgba(245,166,35,.2);border-radius:12px;padding:14px 18px;display:flex;align-items:center;gap:12px;margin-bottom:16px;animation:pFu .45s ease-out .15s both}
.pw .urg-left{flex:1;min-width:0}
.pw .urg-title{font-size:13px;font-weight:700;color:#78350F;margin-bottom:5px}
.pw .urg-title span{font-weight:600;color:#92400E}
.pw .cd{display:flex;gap:4px;align-items:baseline}
.pw .cd-u{text-align:center;min-width:32px}
.pw .cd-n{font-size:18px;font-weight:800;color:#92400E;font-variant-numeric:tabular-nums;line-height:1}
.pw .cd-l{font-size:7px;font-weight:700;text-transform:uppercase;letter-spacing:.08em;color:#B45309;margin-top:1px}
.pw .cd-sep{font-size:15px;font-weight:800;color:#D97706;line-height:1}
.pw .cd-exp{font-size:11px;font-weight:600;color:#DC2626;display:none}
.pw .urgency.expired .cd{display:none}
.pw .urgency.expired .cd-exp{display:block}
.pw .urg-price{flex-shrink:0;text-align:center;border-left:1px solid rgba(245,166,35,.2);padding-left:14px}
.pw .urg-amt{font-size:22px;font-weight:800;color:#78350F;line-height:1}
.pw .urg-per{font-size:11px;color:#92400E;font-weight:600}
.pw .urg-yr{font-size:10px;color:#B45309;margin-top:1px}
.pw .cta-wrap{animation:pFu .45s ease-out .2s both}
.pw .cta-main{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:18px 28px;background:linear-gradient(135deg,#FF6B2C 0%,#E05A1A 100%);color:#fff;font-family:"Outfit",sans-serif;font-size:17px;font-weight:700;border:none;border-radius:14px;cursor:pointer;letter-spacing:.01em;box-shadow:0 5px 20px rgba(255,107,44,.3),0 2px 6px rgba(0,0,0,.06);position:relative;overflow:hidden;transition:transform .15s ease,box-shadow .15s ease}
.pw .cta-main::after{content:"";position:absolute;top:0;left:-100%;width:100%;height:100%;background:linear-gradient(90deg,transparent,rgba(255,255,255,.12),transparent);animation:pSh 3.5s ease-in-out infinite}
.pw .cta-main:hover{transform:translateY(-1px);box-shadow:0 7px 28px rgba(255,107,44,.35)}
.pw .cta-main:active{transform:scale(.98)}
.pw .cta-main svg{width:18px;height:18px;flex-shrink:0}
.pw .cta-sec-wrap{text-align:center;margin-top:14px}
.pw .cta-sec{color:#6B7280;font-size:13px;font-weight:500;padding:6px 4px;display:inline-block;transition:color .15s ease;background:none;border:none;cursor:pointer;font-family:"Outfit",sans-serif}
.pw .cta-sec:hover{color:#0052CC}
.pw .cta-sec .arr{display:inline-block;margin-left:3px;transition:transform .15s ease}
.pw .cta-sec:hover .arr{transform:translateX(3px)}
.pw .trust{text-align:center;padding:16px 24px 24px;animation:pFu .45s ease-out .25s both}
.pw .trust-row{display:flex;justify-content:center;gap:18px;flex-wrap:wrap}
.pw .trust-i{display:flex;align-items:center;gap:4px;font-size:11px;font-weight:600;color:#6B7280}
.pw .trust-i svg{width:13px;height:13px}
@keyframes pFd{from{opacity:0;transform:translateY(-8px)}to{opacity:1;transform:translateY(0)}}
@keyframes pFu{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}
@keyframes pSh{0%{left:-100%}40%{left:100%}100%{left:100%}}
`;

export default function MdmPaywallPreview() {
  const cd = useCountdown();
  const navigate = useNavigate();
  const audioRef = useRef(null);

  const stopAudio = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  }, []);

  // Auto-play otp done audio on mount, stop on navigation/unmount
  // useEffect(() => {
  //   const audio = new Audio(
  //     "/audio/Registration page/Script 4b — mdm_otp_done_v1.mp3",
  //   );
  //   audioRef.current = audio;
  //   audio.play().catch(() => {});

  //   return () => {
  //     audio.pause();
  //     audio.currentTime = 0;
  //     audioRef.current = null;
  //   };
  // }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#E4E7EF",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
    >
      <style>{CSS}</style>
      <div className="pw">
        <section className="hero">
          <div className="stars-mini" style={{ textAlign: "center" }}>
            <StarIcon />
            <StarIcon />
            <StarIcon />
            <StarIcon />
            <StarIcon />
          </div>
          <div className="logo-slot" />
          <div className="status-row">
            <div className="pill">
              <div className="ck">
                <CheckIcon />
              </div>
              {/* <span>रजिस्ट्रेशन पूरा!</span> */}
              <span>आपका रजिस्ट्रेशन पूरा हो गया है!</span>
            </div>
            {/* <div className="stars-mini">
              <StarIcon />
              <StarIcon />
              <StarIcon />
              <StarIcon />
              <StarIcon />
            </div> */}
          </div>
          <div className="proof-num">
            <b>50,000+</b> शिक्षकों का भरोसा
          </div>
          <div className="hl">
            <h1>
              सभी Features <em>Unlock</em> करें
            </h1>
          </div>
        </section>
        <div className="content">
          <div className="checklist">
            {/* <div className="checklist-label">आपको क्या मिलेगा</div> */}
            {CHECKLIST.map((item) => (
              <div className="check-item" key={item}>
                <svg
                  className="check-ico"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#0FAA5C"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <span>{item}</span>
              </div>
            ))}
          </div>
          <div className={`urgency${cd.expired ? " expired" : ""}`}>
            <div className="urg-left">
              <div className="urg-title">
                One time offer for new Registration
                <br />
                {/* Welcome offer for new registered users */}
                {/* Registration Offer! */}
                {/* <span>— सीमित समय</span> */}
                {/* <span>— सिमित समय के लिए</span> */}
              </div>
              <div className="cd">
                <div className="cd-u">
                  <div className="cd-n">{pad(cd.h)}</div>
                  <div className="cd-l">Hrs</div>
                </div>
                <div className="cd-sep">:</div>
                <div className="cd-u">
                  <div className="cd-n">{pad(cd.m)}</div>
                  <div className="cd-l">Min</div>
                </div>
                <div className="cd-sep">:</div>
                <div className="cd-u">
                  <div className="cd-n">{pad(cd.s)}</div>
                  <div className="cd-l">Sec</div>
                </div>
              </div>
              <div className="urg-title" style={{ marginTop: "4%" }}>
                <span>— सिमित समय के लिए</span>
              </div>
              <div className="cd-exp">⏰ Offer समाप्त — फिर भी देखें!</div>
            </div>
            <div className="urg-price">
              {/* <div className="urg-amt">₹21</div>
              <div className="urg-per">/month से</div>
              <div className="urg-yr">₹250/yr</div> */}
              <div className="urg-amt">₹250</div>
              {/* <div className="urg-per">/Yr </div> */}
              <div className="urg-yr"> For Complete One Year</div>
            </div>
          </div>
          {/* <div
            style={{
              background: "linear-gradient(135deg, #E8F5E9 0%, #F1F8E9 100%)",
              border: "1px solid rgba(76,175,80,.25)",
              borderRadius: "12px",
              padding: "14px 18px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginBottom: "16px",
              cursor: "pointer",
            }}
            onClick={() => {
              stopAudio();
              navigate("/pricing", { state: { couponCode: "WELCOME20" } });
            }}
          >
            <div style={{ flex: 1 }}>
              <div
                style={{
                  fontSize: "13px",
                  fontWeight: 700,
                  color: "#1B5E20",
                  marginBottom: 4,
                }}
              >
                Additional 20% Discount
                <br />
                (Offer valid for new users)!
              </div>
              <div style={{ fontSize: "12px", color: "#2E7D32" }}>
                Use code:{" "}
                <span
                  style={{
                    fontWeight: 800,
                    color: "#1B5E20",
                    background: "#C8E6C9",
                    padding: "2px 8px",
                    borderRadius: "4px",
                    letterSpacing: "1px",
                  }}
                >
                  WELCOME20
                </span>
              </div>
            </div>
            <button
              style={{
                background: "linear-gradient(135deg, #43A047, #2E7D32)",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                padding: "8px 16px",
                fontWeight: 700,
                fontSize: "13px",
                cursor: "pointer",
                whiteSpace: "nowrap",
              }}
              onClick={(e) => {
                e.stopPropagation();
                stopAudio();
                navigate("/pricing", { state: { couponCode: "WELCOME20" } });
              }}
            >
              Avail Now <span style={{ marginLeft: 4 }}>→</span>
            </button>
          </div> */}
          <div
            style={{
              background: "linear-gradient(135deg, #E8F5E9 0%, #F1F8E9 100%)",
              border: "1px solid rgba(76,175,80,.25)",
              borderRadius: "12px",
              padding: "14px 18px",
              // display: "flex",
              // alignItems: "center",
              gap: "12px",
              marginBottom: "16px",
              cursor: "pointer",
              // height: "15vh",
            }}
            onClick={() => {
              stopAudio();
              navigate("/pricing", { state: { couponCode: "WELCOME20" } });
            }}
          >
            <div style={{ width: "100%" }}>
              <div
                style={{
                  fontSize: "13px",
                  fontWeight: 700,
                  color: "#1B5E20",
                  marginBottom: 4,
                }}
              >
                This one time 20% offer is only for new users for next 2 hours
              </div>
              <hr />
              <div
                style={{
                  fontSize: "12px",
                  color: "#2E7D32",
                  display: "flex",
                  justifyContent: "center",
                  // justifyContent: "flex-end",
                  alignItems: "center",
                  gap: "8px",
                  marginTop: "2%",
                  width: "100%",
                }}
              >
                {/* Use code: Wrap button + badge in a column */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <button
                    style={{
                      background: "linear-gradient(135deg, #43A047, #2E7D32)",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "8px 16px",
                      fontWeight: 700,
                      fontSize: "13px",
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      stopAudio();
                      navigate("/pricing", {
                        state: { couponCode: "WELCOME20" },
                      });
                    }}
                  >
                    Apply Offer Code <span style={{ marginLeft: 4 }}>→</span>
                  </button>

                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: 800,
                      color: "#1B5E20",
                      background: "#C8E6C9",
                      padding: "2px 8px",
                      borderRadius: "4px",
                      letterSpacing: "1px",
                    }}
                  >
                    WELCOME20
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="cta-wrap">
            <button
              className="cta-main"
              onClick={() => {
                stopAudio();
                navigate("/pricing");
              }}
            >
              Offers देखें <ArrowIcon />
            </button>
            <div className="cta-sec-wrap">
              <button
                className="cta-sec"
                onClick={() => {
                  stopAudio();
                  navigate("/dashboard");
                }}
              >
                Free modules से शुरू करें <span className="arr">→</span>
              </button>
            </div>
          </div>
        </div>
        <footer className="trust">
          <div className="trust-row">
            <div className="trust-i">
              <ShieldIcon />
              Secure Payment
            </div>
            <div className="trust-i">
              <TickIcon />
              Instant Activation
            </div>
            <div className="trust-i">
              <CircleTickIcon />
              One-Time Payment
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
